module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Tools/Compass-1f362f6132467dda62b222ee56f07067.svg";